/**
 * @external {Inquirer} https://github.com/sboudrias/Inquirer.js
 */

/**
 * Must be one of: 'list', 'rawlist', 'expand', 'checkbox', 'confirm', 'input', 'password',
 * 'editor'.
 * @typedef {String} inquirer~PromptType
 * @see https://github.com/sboudrias/Inquirer.js#prompt-types
 */

/**
 * A function that, when called with a value, validates this value and either retunrs `true` if
 * validation succeeded or an error message.
 * @typedef {function(value: String): Boolean|String} inquirer~Validator
 */
